import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, Signal, contentChildren, effect } from '@angular/core';

import { AbstractVerticalTabGroup } from './vertical-tab-group/abstract-vertical-tab-group';

@Component({
  selector: 'mp-vertical-tabs',
  templateUrl: './vertical-tabs.component.html',
  styleUrl: './vertical-tabs.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgTemplateOutlet],
})
export class VerticalTabsComponent {
  protected readonly tabs: Signal<readonly AbstractVerticalTabGroup[]> = contentChildren(AbstractVerticalTabGroup);

  constructor() {
    effect(() => this.selectTab(0));
  }

  selectTab(index: number): void {
    this.tabs().forEach((tab, i) => tab.updateSelectedState(i === index));
  }
}
